export default __webpack_public_path__ + "static/media/momo06.5b3a5d74.png";